import { useEffect, useState } from 'react';
import { Td, Tr, Text, Flex, Input, Button, IconButton } from '@chakra-ui/react';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { ScheduleWeek, textByDayOfTheWeek } from '@/model/schedule-week';
import { useTranslation } from 'react-i18next';

export interface ApplicationCalendarWeekScheduleTableRowProps {
  item: ScheduleWeek;
  onSaveClick?: (item: ScheduleWeek) => void;
  onDeleteClick?: (item: ScheduleWeek) => void;
}

export const ApplicationCalendarWeekScheduleTableRow = ({
  item,
  onSaveClick,
  onDeleteClick,
}: ApplicationCalendarWeekScheduleTableRowProps) => {
  const [description, setDescription] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    if (!item) return;
    setDescription(item?.description);
  }, [item]);

  return (
    <Tr>
      <Td w={{ md: '20%' }}>
        <Text>{item?.days_of_week ? textByDayOfTheWeek[item?.days_of_week] : '-'}</Text>
      </Td>

      <Td>
        <Input
          maxW={{ md: '80%' }}
          textAlign='left'
          value={description}
          onChange={event => setDescription(event.target.value)}
          backgroundColor='white'
          borderColor='gray.300'
          borderRadius={8}
        />
      </Td>

      <Td
        w={{ md: '10%' }}
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
        }}
      >
        <Flex gap={4} alignItems='center'>
          <Button
            onClick={() =>
              onSaveClick?.({
                ...item,
                description,
              })
            }
          >
            {t('pages.application_calendar_week.components.table_row.save_button')}
          </Button>

          <IconButton
            aria-label={t('pages.application_calendar_week.components.table_row.delete_aria_label')}
            variant=''
            icon={<ChakraFeatherIcon name='trash-2' color='red.600' onClick={() => onDeleteClick?.(item)} />}
          />
        </Flex>
      </Td>
    </Tr>
  );
};
